export default {
    userDetails: {
        "avatar": "大頭貼",
        "verificationPhoto": "驗證照",
        "photoUnavailable": "無照片或載入失敗",

        loadingTags: '正在載入標籤',
        "history": "查詢紀錄",
        "historyEmpty": "尚無查詢紀錄。",
        "historyView": "查看",
        "historyDelete": "刪除",
        "historyHint": "保存在此瀏覽器，依管理員帳號分開。查看為當時的資料快照；需要最新資料可按「開始查詢」。",
        "historyRestored": "已載入查詢紀錄（非即時資料）：",
        "historySaved": "已儲存至查詢紀錄。",
        "historySaveFailed": "本次紀錄未儲存：儲存空間不足或無法使用，請刪除舊紀錄後重試。",
        "historyReadFailed": "無法讀取查詢紀錄，儲存資料可能損壞或瀏覽器不允許存取。",
        "historyDeleteFailed": "刪除失敗，請重試。",
        "historyRegionUnavailable": "目前無法管理此紀錄的城市，無法還原。",

        "title": "查詢重複用戶",
        "intro": "匯入 CSV，依原組別查詢會員完整資料。",
        "file": "選擇 CSV 檔案",
        "help": "需要「組別」與「resumeID」（或 ID）欄位。ID 一律視為 Resume ID；先在選定城市查 UID，再以 UID 搜尋完整資料。",
        "search": "開始查詢",
        "denied": "此功能僅限管理員使用。",
        "ready": "已匯入",
        "rows": "筆",
        "groups": "組",
        "invalid": "CSV 格式不正確，請確認組別及 resumeID 欄位皆有值。",
        "noCities": "請先選擇可管理的國家與城市。",
        "resolve": "正在查找 UID",
        "details": "正在查詢會員詳細資料",
        "done": "查詢完成",
        "partial": "查詢完成，部分會員資料未取得；請查看各列狀態。",
        "group": "組別",
        "missing": "此城市未找到 Resume ID 或缺少 UID",
        "unknown": "UID 查詢不完整，請重試",
        "failed": "UID 詳細資料查詢失敗，請重試",
        "missingDetail": "UID 搜尋未返回此會員履歷",
        "empty": "—",
        "country": "國家",
        "city": "城市",
        "open": "在用戶頁開啟",
        "email": "Email",
        "introduction": "自我介紹",
        "gender": "性別",
        "age": "年齡",
        "actualAge": "實際年齡",
        "language": "App 語言",
        "rating": "評分",
        "signUps": "報名次數",
        "remarks": "備註",
        "tags": "標籤",
        "blacklist": "黑名單等級",
        "goodRates": "好評次數",
        "needReverify": "需重新真人驗證",
        "tagWarning": "標籤名稱載入失敗，暫時顯示標籤 ID。"
    },

    home: {
        "description": "從這裡設定你的工作環境，開始今天的管理工作。",
        "languageTitle": "選擇語言",
        "languageDescription": "使用你熟悉的語言瀏覽管理後台。",
        "trainingTitle": "訓練模式（Training Mode）",
        "trainingDescription": "在模擬資料中熟悉操作，練習結果不影響正式資料。",
        "trainingLabel": "啟用訓練模式",
        "agentsTitle": "Agents 使用說明",
        "agentsDescription": "從安裝到第一個任務，帶你設定 AI agent 並複製專用提示詞。",
        "agentsLink": "查看安裝與使用教學"
    },
    agentGuide: {
        "routeTitles": {
            "agent/setup": "Agents 使用說明",
            "login": "登入",
            "index": "首頁",
            "users": "用戶與會員資料",
            "review": "照片驗證",
            "meetups": "聚會場次與桌型",
            "group": "分組與參加紀錄",
            "restaurant": "餐廳與訂位標記",
            "feedback": "回饋與分析",
            "feedback-ai-analysis": "AI 活動回饋分析",
            "notification": "通知與推播",
            "notificationedit": "編輯通知與推播",
            "edm": "EDM 與郵件內容",
            "edmedit": "編輯 EDM",
            "EDMGenerator": "EDM 內容編輯器",
            "promocode": "優惠碼",
            "promocodeedit": "編輯優惠碼",
            "billing": "帳務資訊",
            "seasonpass": "季票",
            "countrycity": "國家與城市管理",
            "manager": "管理員與權限",
            "analyze": "報名分析",
            "userDetails": "查詢重複用戶",
            "deeplink": "DeepLink 工具",
            "ai_gen": "分組 AI 輔助",
            "modelinfo": "分組模型說明",
            "highriskinfo": "風險分析說明",
            "high_risk_report": "風險評估報告",
            "quicksetup": "快速設定",
            "themetable": "舊主題桌管理",
            "themetableedit": "舊主題桌編輯"
        },
        "groupField": "群組 {id}：{field}",
        "link": "agents guide",
        "skip": "跳至主要內容",
        "navigation": "CRM 功能導覽",
        "labels": {
            "session": "場次時間",
            "restaurant": "餐廳",
            "reservation": "訂位姓名",
            "remarks": "備註",
            "model": "分組模型",
            "locked": "鎖定",
            "saveGroup": "儲存群組",
            "country": "國家",
            "city": "城市",
            "date": "聚會日期",
            "startDate": "開始日期",
            "endDate": "結束日期",
            "gender": "性別篩選",
            "signUps": "報名次數篩選",
            "ageFilter": "年齡篩選",
            "rating": "評分篩選",
            "introduction": "自介篩選",
            "blacklist": "黑名單篩選",
            "language": "語言篩選",
            "nationality": "國籍篩選",
            "tagMode": "標籤篩選模式",
            "account": "帳號（Email）",
            "password": "密碼",
            "sidebar": "收合或展開側邊導覽",
            "selectAll": "選取全部用戶",
            "searchGroup": "搜尋群組 ID",
            "groupID": "群組 ID",
            "destinationSession": "目的地場次",
            "destinationCountry": "目的地國家",
            "destinationCity": "目的地城市",
            "search": "搜尋"
        }
    },
    quicksetup: {
        "title": "快速設定 — WKND Club CRM",
        "eyebrow": "每週例行工作",
        "heading": "快速設定",
        "description": "依序完成場次、分組、餐廳確認及配對；各步驟會即時儲存，離開或捨棄草稿不會還原已完成操作。",
        "context": "{city} ／ {time}",
        "stepMeet": "選擇場次",
        "stepGroup": "自動分組",
        "stepRestaurant": "確認餐廳",
        "stepAssign": "配對餐廳",
        "stepDone": "完成",
        "stepOne": "步驟 1",
        "stepTwo": "步驟 2",
        "stepThree": "步驟 3",
        "stepFour": "步驟 4",
        "chooseMeetHeading": "選擇本週場次",
        "chooseMeetShortcut": "選城市、選場次",
        "country": "國家",
        "city": "城市",
        "selectCountry": "選擇國家",
        "selectCity": "選擇城市",
        "startDate": "週期開始",
        "endDate": "週期結束",
        "reloadMeets": "讀取場次",
        "continueGrouping": "下一步：分組",
        "meetTime": "聚會時間",
        "deadline": "報名截止",
        "groupHeading": "執行自動分組",
        "groupShortcut": "檢查人數，再分組",
        "groupCount": "群組數",
        "groupedCount": "已分組人數",
        "ungroupedCount": "未分組人數",
        "promoSummary": "需要排除優惠碼嗎？",
        "promoHelp": "勾選後，使用這些優惠碼的人不會進入本次自動分組。",
        "ungroupedNotice": "目前仍有 {count} 人未分組，請確認是否需要安排。",
        "back": "上一步",
        "keepGroups": "沿用目前分組",
        "runGrouping": "執行自動分組",
        "restaurantHeading": "確認已訂位餐廳",
        "restaurantShortcut": "每組選一間餐廳",
        "restaurantNeed": "需要餐廳",
        "restaurantSelected": "已選擇",
        "bookingHelp": "請先人工完成訂位；此步驟只在系統內標記已訂位，不會聯絡餐廳。",
        "confirmRestaurants": "確認並標記已訂位",
        "assignHeading": "確認群組與餐廳配對",
        "assignShortcut": "檢查配對、完成設定",
        "assignHelp": "系統依現有用餐紀錄優先減少重複餐廳；請確認容量、需求與訂位資訊後再儲存。",
        "group": "群組",
        "attendees": "人數",
        "restaurant": "餐廳",
        "reservationName": "訂位名稱",
        "repeatRisk": "重複狀況",
        "status": "狀態",
        "finish": "確認配對並完成",
        "lockHelp": "完成後會逐組儲存餐廳及訂位名稱，並鎖定群組；已鎖定群組保持原設定。",
        "completeHeading": "本場設定完成",
        "completeDescription": "餐廳訂位標記及群組配對已完成；若仍有未分組人員，請到分組頁處理。",
        "openGroups": "開啟分組頁",
        "openRestaurants": "開啟餐廳頁",
        "startAnother": "設定下一場",
        "draftFound": "找到尚未完成的設定",
        "resumeDraft": "繼續設定",
        "discardDraft": "捨棄草稿",
        "draftDescription": "城市 {city} ／ {time}",
        "draftDiscarded": "本機草稿已移除，已寫入的分組與訂位資料不會還原。",
        "draftRestored": "已恢復草稿並核對最新資料",
        "restoringDraft": "正在恢復草稿…",
        "draftMeetUnavailable": "草稿的場次已無法使用，請重新選擇。",
        "draftGroupsUnavailable": "群組資料已改變，請重新確認分組。",
        "loadingMeets": "正在讀取場次…",
        "noMeets": "此日期區間沒有場次",
        "openCityManager": "前往聚會管理",
        "meetsLoaded": "已讀取 {count} 筆場次",
        "selectCityFirst": "請先選擇城市",
        "selectDates": "請選擇開始與結束日期",
        "invalidDateRange": "結束日期不得早於開始日期",
        "loadMeetsFailed": "讀取場次失敗，請重試。",
        "selectMeetFirst": "請先選擇場次",
        "loadingGroups": "正在讀取分組…",
        "groupsLoaded": "分組資料已更新",
        "loadGroupsFailed": "讀取分組失敗，請重試。",
        "needGroups": "請先完成分組",
        "groupingInProgress": "正在執行自動分組…",
        "groupingReturnedEmpty": "未取得分組結果，請到分組頁確認。",
        "groupingSuccess": "已完成分組，共 {count} 組",
        "groupingFailed": "自動分組失敗，請確認目前結果後再重試。",
        "loadingRestaurants": "正在讀取餐廳…",
        "noRestaurants": "目前沒有可選擇的餐廳",
        "restaurantsLoaded": "已讀取 {count} 間餐廳",
        "loadRestaurantsFailed": "讀取餐廳失敗，請重試。",
        "noAddress": "尚無地址",
        "alreadyBooked": "已標記訂位",
        "bookingFailed": "訂位標記失敗",
        "restaurantCountMismatch": "請選擇 {count} 間餐廳，每組一間。",
        "bookingInProgress": "正在標記訂位…",
        "bookingPartialFailure": "部分訂位標記失敗，已保留成功項目，請重試未完成項目。",
        "bookingSuccess": "訂位標記已完成",
        "returnToAssignments": "返回餐廳配對",
        "noAssignments": "尚無餐廳配對",
        "repeatCount": "{count} 人曾去過",
        "noRepeat": "未發現重複",
        "saved": "已儲存",
        "saveFailed": "儲存失敗",
        "saving": "儲存中…",
        "notSaved": "待儲存",
        "selectRestaurant": "選擇餐廳",
        "assignmentCountError": "配對數量與群組數不符，請重新確認。",
        "assignmentRestaurantError": "每個群組都需要選擇餐廳",
        "assignmentReservationError": "請填寫每組的訂位名稱",
        "assignmentDuplicateError": "同一間餐廳不能配給多個群組，請調整。",
        "assignmentInvalid": "請確認餐廳配對資料",
        "savingGroups": "正在儲存群組配對…",
        "groupSavePartialFailure": "部分群組儲存失敗，已保留成功項目，請重試。",
        "completeToast": "快速設定已完成",
        "completedGroups": "已完成群組",
        "completedPeople": "已安排人數",
        "completedRestaurants": "已安排餐廳",
        "readFailed": "資料讀取失敗，請重新讀取後再操作。",
        "lockedGroups": "已有鎖定群組；快速設定不會重新分組，請沿用目前分組，或至分組頁調整。",
        "changedData": "群組或訂位資料已變更，請重新讀取並確認後再儲存。",
        "lockedConflict": "已鎖定群組的餐廳無法沿用，請先到分組頁確認。",
        "writeNotice": "此操作會立即寫入後端，捨棄草稿不會撤銷。",
        "confirmRegroup": "重新分組會變更目前未鎖定的分組，是否繼續？",
        "ambiguousMeet": "同城市同時間有多筆場次，現有分組 API 無法區分。請先至分組頁確認，快速設定暫不處理此時段。",
        "sessionClosed": "已停用",
        "sessionStarted": "聚會已開始",
        "storageFailed": "本機草稿儲存失敗；請勿關閉頁面，並確認瀏覽器允許儲存。",
        "noCountries": "沒有可管理的國家",
        "noCities": "沒有可管理的城市",
        "scopeHelp": "此流程依城市與聚會時間操作，並不會新增場次。"
},
    workspace: {
        presetAddWeek: "新增{week} {title}",
        presetThisWeek: "本週",
        presetNextWeek: "下週",
        presetMore: "更多",
        presetMoreTitle: "所有桌型預設場次",
        presetConfirmTitle: "新增場次細節",
        presetCreate: "新增",

        editSession: '編輯場次',
        sessionThemeHintBefore: "如在列表找不到桌型，請前往「",
        sessionThemeHintAfter: "」補齊英文文案。",
        sessionTable: '桌型',
        sessionDeadline: '報名截止',
        sessionCapacity: '名額上限',
        sessionLocaleCount: '{count} 種語系',

        newSession: "新增場次",
        sessionIntro: "建立一個單次實際聚會場次；App 文案在桌型管理維護。",
        sessionStepOne: "步驟 1：場次資料",
        sessionStepTwo: "步驟 2：確認建立",
        sessionThemeHint: "如在列表找不到桌型，請前往「桌型管理」補齊英文文案。",
        sessionDate: "聚會日期",
        sessionTime: "聚會時間",
        sessionCityZone: "城市與時區",
        sessionPrecheck: "送出前自動檢查",
        sessionCheckTheme: "選擇桌型後，可在右側預覽英文與其他語系文案。",
        sessionCheckDeadline: "報名截止需嚴格早於聚會日期與時間。",
        sessionCheckDuplicate: "同城市、同桌型、同時間的既有場次會顯示提醒。",
        sessionSelectedTheme: "已選桌型",
        sessionAppPreview: "App 文案預覽",
        sessionFinalCheck: "建立前檢查",
        sessionRequiredComplete: "必填欄位完整。",
        sessionBack: "← 返回修改",
        sessionDuplicateFound: "已有相同城市、桌型與時間的啟用場次，無法重複建立。請重新載入場次列表。",
        sessionNoDuplicate: "未發現同城市、同桌型、同時間的既有場次。",

        appCityImages: 'App 城市圖',
        discountable: '是否可折扣',
        discountableHint: '選擇無法折扣代表此桌型不能使用任何優惠碼',
        discountAllowed: '可折扣',
        discountDenied: '無法折扣',
        inlineCopy: 'App 文案（多語系）',
        inlineAddLocale: '新增語系',
        inlineLocaleTooLong: '顯示標題限 20 字元，詳細說明限 200 字元，請縮短超出上限的內容。',
        inlineLocaleHelp: '語系標題與說明文可留空，不要求英文文案。未修改的既有語系與全空白的新語系不會送出。已儲存語系不提供移除。若部分儲存失敗，已成功的資料仍會保留，可重試其餘項目。',
        duplicateLocale: '同一主題桌不可重複加入相同語系。',
        duplicateThemeType: '此城市已有相同類型識別名稱，請使用其他名稱或編輯既有主題桌。',
        themeLookupFailed: '主題桌已建立，但無法唯一確認 meetTypeID。請重試查詢，或重新讀取列表後編輯；不會再次建立主題桌。',
        themeScopeChanged: '城市已變更，請關閉表單後重新開啟。',
        localeSaveHint: '語系文案會分別儲存；取消桌型編輯不會還原已儲存的文案。',
        sessionStarted: '聚會已開始，不可編輯',
        returnToSession: '返回新增場次（保留草稿）',
        createThemeForSession: '前往桌型管理建立或補齊文案',
        draftSaveFailed: '草稿無法暫存，請確認瀏覽器允許本機儲存。',
        draftClearFailed: '場次已建立，但本機草稿未能清除。',
        imageChecking: '待檢查',
        imagePresent: '已設定',
        imageUnavailable: '無圖片／無法載入',

        backToCityList: '返回列表',
        cityImageNotSet: '尚未設定',
        cityImageUploadHint: '選擇檔案後立即上傳，不需另按儲存；取消城市編輯不會還原已上傳的圖片。',
        cityArea: '地區背景圖（英）',
        cityAreaLocation: '地區背景圖',
        uploadCityImage: '上傳圖片',
        replaceCityImage: '替換圖片',
        invalidCityImage: '請選擇有效的圖片檔案與圖片類型。',
        cityImageUploading: '圖片上傳中，請稍候。',
        cityImageUploaded: '圖片上傳成功',
        cityImageUploadFailed: '圖片上傳失敗，請重試。',
        signUps: '報名人數',
        registrationStatus: '報名狀態',
        sessionAvailable: '可報名',
        sessionUnavailable: '已停用',
        signUpsUnknown: '尚無報名人數資料，無法移除。',
        sessionHasSignUps: '此場次已有人報名，無法移除。',

        cityThumbnail: '城市縮圖',
        cityBookingImage: '城市圖',
        cityImageLoadFailed: '圖片無法載入',

        createCountryData: '+ 建立新國家資料',
        addCityDistrict: '新增城市 / 地區',
        displayName: 'App 內顯示名稱', category: '分類', missingEnglish: '待補英文', placeCount: '國家（{countries}）／城市（{cities}）／地區（{districts}）',
    "meetings": "聚會管理",
    "countries": "國家與城市管理",
    "themes": "桌型管理",
    "searchPlaces": "搜尋國家、城市或地區",
    "editCountry": "編輯國家",
    "currency": "幣別",
    "symbol": "貨幣符號",
    "status": "狀態",
    "languageName": "語言名稱",
    "countryLanguageRequired": "請填寫語言名稱與語言代碼。",
    "languageCode": "語言代碼",
    "addLanguage": "新增語言",
    "saveFailed": "儲存失敗，請重試",
    "saved": "儲存成功",
    "languageExists": "此語言已存在",
    "places": "國家／城市／地區",
    "invalidSession": "請完整填寫場次資料，名額須為正整數",
    "invalidDeadline": "報名截止必須早於聚會時間",
    "duplicateSession": "同城市、桌型與時間的場次已存在",
    "englishRequired": "請先啟用桌型並補齊英文標題與說明文",
    "createSession": "建立場次",
    "next": "下一步：預覽並確認",
    "back": "返回修改",
    "arrange": "安排場次",
    "searchThemes": "搜尋 App 內顯示名稱",
    "addBrunchType": "＋新增早午餐型",
    "addTeaType": '＋新增下午茶桌型',
    "themeTemplateDetails": '新增主題桌細節',
    "templateKnowledge": '1（知識型）',
    "templateSharing": '2（分享型）',
    "addBookType": "＋新增書蟲桌型",
    "allStatuses": "全部狀態",
    "allTypes": "全部桌型",
    "addBrunchSession": "＋新增本週早午餐",
    "addBookSession": "＋新增本週書蟲桌",
    "missingTemplate": "尚無符合且已啟用的桌型，請先至桌型管理建立並補齊英文文案",
    "unsaved": "尚有未儲存內容，確定離開？"
},
    deeplink: {
        "seasonLocation": "指定季票購買地區（未勾選時沿用 App 目前地區）",
        "directHelp": "輸入既有場次 ID；App 以此 ID 載入購買資訊，不套用地區或時段條件。",
        "meetTimeID": "場次 ID（meetTimeID）",
        "directPurchase": "指定場次直接購買",
        "title": "DeepLink",
        "instructionsTitle": "DeepLink 使用說明",
        "introLink": "固定連結：所有 DeepLink 都使用既有 OneLink：wkndclub.onelink.me/66q3。",
        "introPid": "pid（媒體來源）：標記連結來源；可使用預設值或自訂值，且必填。",
        "introValue": "目的頁：season_pass 為季票，可不帶地區或完整帶 sub1～sub3；booking_checkout 為主題桌／早午餐結帳，早午餐固定 meetTypeID=1。指定場次直接購買只帶 pid 與 meetTimeID，不混入其它導頁條件。",
        "introCountry": "deep_link_sub1（countryID）：國家 ID；國家可自由選擇。",
        "introCity": "deep_link_sub2（cityID）：App 使用的上層城市 ID。",
        "introDistrict": "deep_link_sub3（districtID）：服務地區／分區 ID；沒有分區時等於 cityID。",
        "introTheme": "deep_link_sub4（meetTypeID）：主題桌類型 ID。",
        "introSlot": "deep_link_sub5（指定時段）：指定時段模式的活動時間，格式為 yyyyMMddHHmmss；最近可預訂模式不帶此參數。",
        "introFlag": "deep_link_sub10：季票／條件結帳固定為 1；指定場次 ID 直接購買不需要。",
        "introRules": "僅提供 coming=0 的城市。指定時段依日期自動查詢，迄日須大於起日；排除缺少場次 ID、過期及重複時間，以單選按鈕選取。",
        "introApp": "App 行為：最近模式開啟時選擇最近有效場次；指定時段失效或有多筆符合時返回預訂頁。App 重新驗證資料與資格；付款中會忽略購買連結。",
        "introLimits": "時間與限制：日期時間依活動所在地時區；未登入時只開啟 App。本工具只產生連結，不建立訂單或付款。",
        "action": "目的頁",
        "season": "季票購買頁",
        "brunch": "早午餐結帳頁",
        "booking": "主題桌結帳頁",
        "source": "媒體來源（pid）",
        "custom": "自行輸入",
        "customSource": "自訂媒體代碼",
        "country": "國家",
        "city": "城市",
        "district": "地區",
        "theme": "主題桌",
        "mode": "日期模式",
        "nearest": "最近可預訂場次",
        "exact": "指定時段",
        "start": "查詢起日",
        "end": "查詢迄日",
        "slot": "聚會時段",
        "choose": "請選擇",
        "copy": "複製連結",
        "testLink": "測試連結",
        "copied": "已複製連結",
        "copyFailed": "無法自動複製，請選取下方連結手動複製。",
        "preview": "連結預覽",
        "ready": "連結已就緒",
        "incomplete": "請完成必填選項，才能產生連結。",
        "loading": "載入中…",
        "api": "資料載入失敗，請重新選擇或重試。",
        "denied": "DeepLink 僅限 auth = 1 的管理員使用。",
        "retry": "重新載入地區",
        "timezone": "活動時區",
        "unknownTimezone": "缺少有效活動時區，無法查詢指定時段。",
        "range": "請填入有效日期區間（迄日必須大於起日，最長 366 天）。",
        "noBrunchSlots": "目前早午餐桌沒有時段。",
        "noThemeSlots": "目前此主題桌沒有時段。",
        "noThemes": "此地區沒有可用主題桌。",
        "noCities": "此國家沒有可對應的城市。",
        "noCountries": "沒有可用國家資料。",
},
    languageName: '繁體中文',

    // Common elements
    common: {
        welcome: '歡迎',
        login: '登入',
        logout: '登出',
        save: '儲存',
        cancel: '取消',
        delete: '刪除',
        edit: '編輯',
        create: '建立',
        search: '搜尋',
        submit: '送出',
        back: '返回',
        close: '關閉',
        add: '新增',
        menu: '選單',
        copy: '複製',
        copied: '已複製',
        copyfailed: '複製失敗',
        download: '下載',
        processing: '處理中...',
        saving: '儲存中...',
        loading: '載入中...',
        refresh: '重新整理',
        regularphoto: '一般照片',
        verificationphoto: '驗證照片',
        emailcopied: 'Email 已複製',
        clear: '清除',
        nodata: '無資料'
    },

    // Navigation
    nav: {
        quicksetup: "快速設定",
        userDetails: '查詢重複用戶',
        deeplink: 'DeepLink',
        photoverification: '照片驗證',
        groups: '分組',
        feedback: '回饋',
        users: '用戶',
        restaurant: '餐廳',
        administrator: '管理員',
        citymanagement: '城市管理',
        messagesnotifications: '推播',
        promocode: '優惠碼',
        themetable: '主題桌',
        seasonpass: '季票',
        billing: '帳務資訊',
        analyze: '分析',
        edm: 'EDM',
        systememail: '系統 Email'
    },

    analyze: {
        title: 'WKND Club CMS - 分析',
        permissionDenied: '此頁面僅限 authorization = 1 的管理員使用。',
        filterSection: '分析篩選',
        startDate: '開始日期',
        endDate: '結束日期',
        sort: '排序',
        sortApi: '一般順序',
        sortHigh: '報名人數高到低',
        sortLow: '報名人數低到高',
        signUpListTab: '報名人數列表',
        weeklyTrendTab: '每週趨勢',
        period: '期間',
        periodSixMonths: '六個月',
        periodOneYear: '一年',
        reload: '重新讀取',
        chartType: '圖表類別',
        chartTypeLine: '折線圖',
        chartTypeSmoothLine: '平滑折線圖',
        chartTypeArea: '面積圖',
        cityFilter: '顯示城市',
        order: '順序',
        country: '國家',
        city: '城市',
        districts: '地區',
        signUps: '報名人數',
        summary: '城市數 ({cityCount}) / 報名人數 ({signUps})',
        weeklySummary: '共 {weekCount} 週 / 城市數 ({cityCount}) / 報名人數 ({signUps})',
        weeklyCacheSummary: '快取 {cached} 週 / 新讀取 {fetched} 週',
        weeklyLoading: '每週趨勢載入中 {current}/{total}',
        weeklyEmpty: '沒有每週趨勢資料。',
        empty: '此日期區間沒有報名資料。',
        dateRequired: '請選擇開始日期與結束日期。',
        invalidDateRange: '開始日期不可晚於結束日期。',
        loadFailed: '無法載入分析資料。'
    },

    citymanager: {
        title: 'WKND Club CMS - 城市管理',
        meetTimesTab: '實際場次',
        citySettingsTab: '城市設定',
        loadingCountries: '載入國家中...',
        noCountries: '沒有可用國家',
        selectCountry: '選擇國家',
        selectCity: '選擇城市',
        noCitiesForCountry: '此國家沒有可用城市',
        selectCityFirst: '請先選擇城市。',
        reload: '重新讀取',
        dateRequired: '請選擇開始日期與結束日期。',
        invalidDateRange: '開始日期不可晚於結束日期。',
        loadingMeetTimes: '載入聚會時段中...',
        loadedMeetTimes: '已載入 {count} 筆聚會時段',
        loadMeetTimesFailed: '無法載入聚會時段。',
        meetTimesSummary: '聚會時段 ({count})',
        noMeetTimes: '此日期區間沒有聚會時段。',
        addMeetTime: '新增場次',
        updateMeetTime: '編輯場次',
        meetTimeDetails: '聚會時段詳細資料',
        meetTime: '聚會時間',
        deadline: '截止時間',
        tableType: '桌型',
        spots: '席位',
        spotsRequired: '請填寫席位數量。',
        meetTimeRequired: '請填寫聚會時間與截止時間。',
        meetType: '主題桌',
        defaultMeetTypeName: '早午餐桌',
        loadingMeetTypes: '載入主題桌中...',
        loadMeetTypesFailed: '無法載入主題桌。',
        noMeetTypes: '此城市沒有可用的主題桌。',
        meetTypeRequired: '請選擇主題桌。',
        addMeetTimeSuccess: '已新增聚會時段。',
        addMeetTimeFailed: '新增聚會時段失敗。',
        updateMeetTimeSuccess: '已更新場次。',
        updateMeetTimeFailed: '更新場次失敗。',
        updateMeetTimeNeedsID: '此筆資料缺少 cityMeetTimeID，無法更新。',
        deadlineRequired: '請填寫截止時間。',
        removeMeetTime: '刪除場次',
        removeMeetTimeConfirmTitle: '確定刪除以下場次？',
        confirmRemoveMeetTime: '確定刪除',
        removeMeetTimeSuccess: '已移除聚會時段。',
        removeMeetTimeFailed: '移除聚會時段失敗。',
        removeNeedsID: '此筆資料缺少 cityMeetTimeID，無法移除。',
        cityMeetTimeID: 'ID',
        actions: '操作',
        remove: '移除',
        loadCountriesFailed: '無法載入城市資料。',
        loadCountriesFallback: 'All Cities API 失敗，已暫用本機可管理城市資料。',
        initializationFailed: '初始化城市管理頁失敗。',
        citySettingsSummary: '城市 ({count})',
        noCities: '目前沒有城市資料。',
        addCity: '新增城市',
        editCity: '編輯城市',
        createCity: '建立城市',
        updateCity: '更新城市',
        saveCitySuccess: '已儲存城市設定。',
        saveCityFailed: '儲存城市設定失敗。',
        requiredCityFields: '請填寫國家、城市、地區、時區、價格、支付管道與主語言。',
        missingCityID: '缺少 cityID，無法更新城市。',
        country: '國家',
        cityID: 'City ID',
        cityName: '城市',
        districts: '地區',
        timezoneName: '時區',
        timezonePlaceholder: '搜尋時區，例如 Australia/Perth',
        timezoneHelp: '輸入城市或區域搜尋，例如 Australia/Perth。',
        showTimezoneOptions: '顯示時區選單',
        noTimezoneResults: '找不到符合的時區',
        invalidTimezone: '請選擇有效的 IANA 時區，例如 Australia/Perth。',
        price: '價格',
        seasonPrice: '季票價格',
        seasonReps: '季票次數',
        taxRate: '稅率',
        discounted: '折扣',
        promoCode: '優惠碼',
        firstUsePromoUnmatched: '無法對應',
        unresolvedFirstUsePromo: '首次優惠碼無法對應到有效的 promoCodeID，已保留原值且未送出。請重新選擇優惠碼，或重新開啟編輯城市後再試。',
        firstUsePromo: '首次優惠碼',
        selectFirstUsePromo: '選擇優惠碼',
        noFirstUsePromoConfigured: '尚無設定優惠碼',
        loadingPromoCodes: '載入優惠碼中...',
        loadFirstUsePromoFailed: '載入首次優惠碼失敗。',
        support: '客服',
        gateway: '支付管道',
        gatewayStripeNative: 'Stripe 原生支付',
        gatewayStripeCheckout: 'Stripe 網頁支付（Checkout）',
        gatewayTapPay: 'TapPay',
        presale: '預售',
        presaleOn: '開啟',
        presaleOff: '關閉',
        available: '開放狀態',
        availableOpen: '已開放',
        availableClosed: '尚未開放',
        availableRecruiting: '加盟募集中',
        mainLang: '主語言'
    },

    cityMeetTimeRules: {
        pageHeading: '制定聚會時間規則',
        loadingCountries: '載入國家中...',
        noCountries: '沒有可用國家',
        selectCity: '選擇城市',
        noCitiesForCountry: '此國家沒有可用城市',
        selectCityFirst: '請先選擇城市。',
        reload: '重新讀取',
        loadingRules: '載入聚會時間規則中...',
        loadedRules: '已載入 {count} 筆聚會時間規則',
        loadRulesFailed: '無法載入聚會時間規則。',
        rulesSummary: '聚會時間規則 ({count})',
        noRules: '此城市目前沒有聚會時間規則。',
        addMeetTimeRule: '新增聚會時間',
        editMeetTimeRule: '編輯規則',
        updateMeetTimeRule: '更新規則',
        meetTimeRuleID: '規則 ID',
        weekly: '週期（週）',
        weeklyHelp: '（例如：設為 1 代表每一週都有一次聚會、設為 2 代表每兩週才有一次聚會，以此類推）',
        day: '星期',
        dayHelp: '聚會在週間的星期幾',
        startTime: '開始時間',
        endTime: '結束時間',
        deadlineMinutes: '截止時間（分鐘）',
        deadlineMinutesHelp: '活動開始前多少分鐘截止報名。',
        ruleAvailable: '狀態',
        ruleEnabled: '啟用',
        ruleDisabled: '停用',
        daySunday: '星期日',
        dayMonday: '星期一',
        dayTuesday: '星期二',
        dayWednesday: '星期三',
        dayThursday: '星期四',
        dayFriday: '星期五',
        daySaturday: '星期六',
        ruleRequired: '請完整填寫週期、星期、開始時間、結束時間與截止分鐘。',
        missingRuleID: '缺少規則 ID，無法更新。',
        addRuleSuccess: '已新增聚會時間規則。',
        addRuleFailed: '新增聚會時間規則失敗。',
        updateRuleSuccess: '已更新聚會時間規則。',
        updateRuleFailed: '更新聚會時間規則失敗。',
        actions: '操作',
        loadCountriesFailed: '無法載入城市資料。',
        loadCountriesFallback: 'All Cities API 失敗，已暫用本機可管理城市資料。',
        initializationFailed: '初始化制定聚會時間規則頁失敗。'
    },

    // Zodiac Signs
    zodiac: {
        aries: '牡羊座',
        taurus: '金牛座',
        gemini: '雙子座',
        cancer: '巨蟹座',
        leo: '獅子座',
        virgo: '處女座',
        libra: '天秤座',
        scorpius: '天蠍座',
        sagittarius: '射手座',
        capricornus: '摩羯座',
        aquarius: '水瓶座',
        pisces: '雙魚座'
    },

    // EDM
    edm: {
        all: '全部',
        systemEdm: '系統 EDM',
        marketingEdm: '行銷 EDM',
        name: '名稱',
        description: '描述',
        status: '狀態',
        lastmodified: '最後修改',
        actions: '操作',
        subject: '主旨',
        content: '內容',
        statusOptions: {
            active: '啟用',
            inactive: '停用'
        },
        addVersion: {
            title: '新增版本',
            country: '國家',
            city: '城市',
            type: 'EDM 類型',
            language: 'EDM 語言',
            cancel: '取消',
            confirm: '確定',
            button: '新增版本'
        },
        type: '類型',
        language: '語言',
        version: '版本',
        active: '啟用',
        inactive: '停用',
        preview: '預覽',
        edit: '編輯'
    },

    // EDM Edit
    edmEdit: {
        sampleTemplate: '參考樣板（不可編輯）',
        editableContent: '可編輯內容',
        typeVersion: '類型: {type}  |  Version: {version}',
        back: '返回',
        preview: '預覽',
        testSend: '寄送測試信',
        submit: '儲存',
        submitSuccess: '送出成功',
        submitFailed: '送出失敗: {error}',
        testSendSuccess: '測試信已送出',
        testSendFailed: '寄送失敗: {error}'
    },

    // EDM Edit Page (Metadata / EDM 設定頁)
    edmEditPage: {
        sections: {
            settingsTitle: '信件設定',
            contentTitle: '信件編輯'
        },
        fields: {
            type: { label: '類型', placeholder: '請選擇' },
            version: { label: '版本名稱', placeholder: '輸入版本名稱' },
            country: { label: '套用地點', placeholder: '請選擇國家', empty: '尚未選擇地點' },
            language: { label: '語言' },
            subject: { label: '主旨', placeholder: '輸入主旨', limitHint: '字數限制 150 字' },
            testTime: { label: '時間', placeholder: '選擇時間' },
            testLocation: { label: '地點', placeholder: '請輸入地點（可留空）' },
            testAddress: { label: '地址', placeholder: '請輸入地址（可留空）' },
            testLink: { label: '連結', placeholder: '請輸入連結（可留空）' },
            testReservation: { label: '訂位資訊', placeholder: '請輸入訂位資訊（可留空）' }
        },
        actions: {
            editContent: '編輯信件內容',
            testSend: '寄送測試信'
        },
        preview: {
            title: 'EDM 預覽',
            loading: '載入預覽中...',
            error: '取得預覽失敗',
            empty: '尚未建立信件內容'
        },
        tags: {
            empty: '尚未新增'
        },
        history: {
            confirmClear: '確定要清除所有歷史記錄嗎？'
        },
        toasts: {
            missingEdmID: '缺少 edmID，無法載入 EDM 資料',
            missingEdmIDEdit: '缺少 edmID，無法編輯內容',
            missingEdmIDSave: '缺少 edmID，無法儲存',
            loadTypesFailed: '載入 EDM 類型失敗',
            loadDetailFailed: '載入 EDM 資料失敗',
            requiredFields: '請填寫類型與版本名稱',
            subjectTooLong: '主旨字數不可超過 150 字',
            saveSuccess: '儲存成功',
            saveFailed: '儲存失敗',
            testSendUnknown: '寄送失敗，請稍後再試'
        }
    },

    // EDM Generator
    edmGenerator: {
        toasts: {
            missingEdmID: '缺少 edmID，無法儲存',
            saveSuccess: '儲存成功',
            saveFailed: '儲存失敗',
            saveFailedWithReason: '儲存失敗：{error}'
        }
    },
    
    // EDM Edit - Test Send Offcanvas
    testSend: {
        title: '寄送測試信',
        sendingInfo: '寄送資訊',
        name: '名稱',
        namePlaceholder: '請輸入名稱',
        email: 'Email',
        emailPlaceholder: '請輸入 Email',
        sendTime: 'Meet Time',
        edmTestInfo: 'EDM測試資訊',
        cancel: '取消',
        confirmSend: '確定寄送',
        sending: '寄送中',
        sentSuccess: '寄送成功',
        sendHistory: 'Send History',
        clearHistory: '清除歷史',
        errors: {
            nameRequired: '請輸入名稱',
            emailRequired: '請輸入 Email',
            emailInvalid: 'Email 格式錯誤'
        }
    },

    // Dashboard
    dashboard: {
        title: '儀表板',
        summary: '這裡顯示主要內容。',
        recentActivity: '最近活動'
    },

    // Language selection
    language: {
        select: '選擇語言',
        current: '目前語言',
        changeSuccess: '語言已更改',
        zh_Hant: '繁體中文',
        en: '英文',
        ko: '韓文',
        de: '德文',
        ja: '日文'
    },

    // Filter
    filter: {
        selectcountry: '選擇國家',
        selectcity: '選擇城市',
        selecttime: '選擇時間',
        selectmonth: '選擇月份',
        customdaterange: '自訂區間',
        dateto: '至',
        selectcountryfirst: '請先選擇國家',
        nomanageablecities: '此國家無可管理城市'
    },

    // Groups
    groups: {
        creatingGroup: '正在新增組別，請稍候…',
        movingAttendee: '正在移動參加者，請稍候…',
        savingGroup: '正在儲存群組，請稍候…',
        savingGroupReason: '正在儲存分組理由，請稍候…',
        groupingAttendees: '正在自動分組，請稍候…',
        movingSession: '正在更換場次，請稍候…',
        movingCity: '正在更換城市，請稍候…',
        cancellingAttendee: '正在取消參加，請稍候…',
        refundingAttendee: '正在處理退款，請稍候…',
        savingRating: '正在儲存評分，請稍候…',
        savingVerification: '正在儲存照片審核，請稍候…',
        savingTags: '正在更新標籤，請稍候…',
        savingRiskAnalysis: '正在儲存風險分析，請稍候…',
        savingAttendee: '正在更新參加者資料，請稍候…',

        loadingSession: '正在讀取場次資料，請稍候…',
        automaticgrouping: '自動分組',
        aiAutomaticGrouping: 'AI 自動分組',
        aiGrouping: 'AI 功能 & 分組',
        autoGroupingDescription: '依目前選取的場次執行自動分組。',
        aiGroupingDescription: '依序執行自動分組、重新讀取資料、AI 標籤建立與儲存、批次分組評估與儲存，最後完成參加者風險評估與儲存。此流程包含多個步驟，請耐心等候處理完成。',
        cancelGroupingDescription: '關閉視窗，不執行任何分組流程。',
        addgroup: '新增組別',
        modalInfoButton: 'Modal 說明',
        grouped: '已分組',
        ungrouped: '未分組',
        reservationconfirmed: '已訂位',
        people: '人',
        total: '共',
        genderMale: 'Male',
        genderFemale: 'Female',
        genderNonBinary: 'Non-binary',
        selectrestaurant: '選擇餐廳',
        arrangeLogic: '安排邏輯',
        reservationname: '訂位名稱',
        note: '備註',
        enternote: '輸入備註',
        modelInfoTitle: '模型說明',
        modelInfoDescription: '查看分組模型的詳細設定與說明',
        modelId: 'Model 編號',
        modelName: 'Model 名稱',
        modelDetails: 'Model 說明',
        noModels: '目前沒有模型資料',
        modelLoadFailed: '載入模型資料失敗',
        excludepromocode: '請選擇要排除的優惠碼',
        used: '已使用',
        currentuserid: '當前用戶 UID',
        enteruserid: '請輸入 UID',
        resendnotification: '重寄通知',
        refund: '退款',
        refundconfirmation: '你確定要為 {userName} 退款嗎？',
        cancelandrefund: '取消並退款',
        cancelandrefundconfirmation: '你確定要為 {userName} 取消並退款嗎？',
        emailcountlabel: 'Email 清單 (共 {count} 人)',
        noemailsfound: '找不到符合條件的 Email。',
        emailcopiedsuccess: 'Email 已成功複製到剪貼簿！',
        emailcopiederror: '複製 Email 到剪貼簿失敗。',
        nocontenttocopy: '沒有可複製的 Email。',
        nocontenttodownload: '沒有可下載的 Email。',
        emaildownloadedsuccess: '已下載 Email 清單（共 {count} 筆）。',
        emailListModalTitle: 'Email 清單',
        emailListGroupIdPlaceholder: '搜尋GroupID',
        emailListButton: 'Email清單',
        // 當未分組人數不足 50 時於模態框底部顯示的警示文字
        ungroupedLessThan50Alert: '報名人數未達50人將無法觸發最佳演算',
        // 換區功能
        movetime: '換時間',
        movecity: '換區',
        moveschedulecity: '更換區域',
        movescheduletime: '更換時間',
        user: '用戶',
        attendingregion: '參加地區',
        currenttime: '目前時間',
        availabletime: '可用的時間',
        from: '從',
        moveto: '更換至',
        confirmmove: '確定更換',
        partnerInOtherGroupTooltip: '此用戶同桌好友被分到了 {groupId} 組',
        groupDescriptionButton: '分組描述'
    },

    // AI Generator
    aiGen: {
        title: 'AI（beta）',
        featureButton: 'AI 功能',
        description: '顯示目前選擇的分組資料',
        featureTitle: 'AI 功能',
        modelMethodLockedTitle: '正式模式固定使用 Gemini',
        createTags: '標籤建立',
        applyModel: '分組模型評估',
        batchApplyModel: '批次分組評估',
        batchActionEvaluate: '批次AI評估',
        batchActionEvaluating: 'AI評估中',
        batchActionSave: '批次儲存',
        batchActionSaving: '儲存中',
        batchAgeUnit: '歲',
        batchProcessing: '批次分組評估處理中',
        batchEvaluating: '批次 AI 評估中',
        batchSaving: '批次儲存中',
        batchToolbarHint: '共 {count} 組，將以串行方式執行 AI 評估與儲存',
        batchGroupTitle: '組別 {index}（meetGroupID: {groupId} · bookedTime: {bookedTime}）',
        batchEvaluateSummary: 'AI 評估完成：成功 {successCount} 組，失敗 {failureCount} 組',
        batchEvaluateSuccessToast: '批次 AI 評估完成：成功 {successCount} 組',
        batchEvaluateFailureToast: '批次 AI 評估有 {failureCount} 組失敗，請檢查狀態',
        batchSaveSummary: '儲存完成：成功 {successCount} 組，失敗 {failureCount} 組',
        batchSaveSuccessToast: '批次儲存完成：成功 {successCount} 組',
        batchSaveFailureToast: '批次儲存有 {failureCount} 組失敗，請檢查狀態',
        batchSaveReloadConfirm: '批次儲存已完成，是否重新整理頁面以更新畫面資料？',
        batchStatus: {
            pending: '待處理',
            evaluating: '評估中 {current}/{total}',
            evaluated: '評估完成',
            evaluateFailed: '評估失敗',
            saving: '儲存中 {current}/{total}',
            saveSkipped: '無描述略過',
            saved: '已儲存',
            saveFailed: '儲存失敗'
        },
        batchSummary: {
            modelNumber: '分組模型編號：',
            modelName: '分組標題：',
            confidence: '信心度：',
            reasonTitle: '評估重點：',
            cautionTitle: '注意事項：'
        },
        batchTooltip: {
            name: '姓名',
            email: 'Email',
            gender: '性別',
            age: '年齡',
            sign: '星座',
            rate: '評分',
            mbti: 'MBTI',
            lang: '語言',
            nationality: '國籍',
            occupation: '職業',
            resumeID: 'resumeID',
            previousSignUps: '過往報名次數',
            promoCode: '優惠碼',
            dietaryHabit: '飲食習慣',
            repeatPeople: '重複參加者',
            repeatRestaurant: '重複餐廳',
            visitedRestaurant: '曾去過的餐廳',
            recentRestaurant: '最近餐廳',
            restaurantRating: '餐廳評價',
            locationName: '地區',
            reservationName: '訂位名稱',
            remarks: '備註',
            birthdate: '生日',
            group: '組別',
            meetGroupID: 'meetGroupID',
            bookedTime: 'bookedTime',
            unknownUser: '未知用戶',
            unknownTag: '未知標籤',
            noDetails: '尚無詳細資料'
        },
        batchErrors: {
            noAttendees: '該組別沒有參加者資料',
            invalidJson: 'AI 回傳資料無法解析為 JSON',
            missingGroupId: '缺少 groupID，無法更新分組描述'
        },
        tagModal: {
            generateAction: 'AI標籤建立',
            importAction: '標籤匯入資料庫',
            candidateListTitle: '待標籤建立用戶',
            userTagsTitle: '用戶標籤',
            debugToggle: '顯示 AI 提示詞 / 回傳',
            emptyHint: '點擊「AI標籤建立」按鈕生成標籤',
            promptEmpty: '尚無提示詞',
            resultEmpty: '尚無回傳內容',
            emptyList: '尚無標籤資料',
            systemMessage: '系統訊息',
            table: {
                user: '用戶',
                recommendedTags: 'AI 推薦標籤'
            },
            unknownUser: '未知用戶',
            unknownTag: '未知標籤',
            noTag: '無',
            itemPrefix: '項目',
            parseFailed: '解析失敗',
            noRecommendedTags: '無推薦標籤',
            noMatchingTags: '沒有相符的標籤',
            searchTagsPlaceholder: '搜尋標籤...',
            importingStatus: '資料匯入中',
            generatingStatus: 'AI 生成中',
            examplePrompt: '範例提示詞',
            promptLogLabel: '第 {index} 筆提示詞（{participant}）',
            responseLogLabel: '第 {index} 筆回傳（{participant}）',
            retryPromptLabel: '重試提示詞（{participant}）',
            retryResponseLabel: '重試回傳（{participant}）',
            noResponseShort: '無回應',
            callFailedPrefix: '呼叫失敗：{message}',
            retryingItems: '正在重試 {count} 個失敗項目...',
            retryFailedPrefix: '重試失敗：{message}',
            retryErrorRaw: '重試時發生錯誤',
            missingCityForImport: '缺少城市資訊，無法匯入標籤',
            noImportableData: '尚無可匯入的 AI 標籤資料',
            importFailed: '標籤匯入失敗，請稍後再試',
            tagAddFailed: '標籤新增失敗',
            tagRemoveFailed: '標籤移除失敗',
            selectCityFirst: '請先選擇城市',
            addTagFailed: '新增標籤失敗：{tagName}',
            tagAdded: '已新增標籤：{tagName}',
            addCityTagFailed: '新增城市標籤失敗',
            updateTagFailed: '更新標籤失敗',
            removeTagFailed: '刪除標籤失敗'
        },
        applyModelModal: {
            evaluateAction: 'AI評估',
            descriptionSectionTitle: '分組描述',
            copySuccess: '已複製到剪貼簿',
            copyManualFail: '複製失敗，請手動選取複製',
            saveProcessing: '儲存中...',
            saved: '已儲存',
            descriptionSaved: '{language} 分組描述已儲存',
            updateFailed: '更新分組描述失敗',
            noAttendees: '該組別沒有參加者資料',
            missingBlock: '找不到對應的組別區塊',
            evaluatingStatus: 'AI 分組評估中',
            resultTitle: '評估結果',
            parseFailed: 'AI 回傳資料無法解析為 JSON，請查看下方 log。',
            descriptionTitle: '分組描述：',
            reasonTitle: '評估重點：',
            cautionTitle: '注意事項：',
            logTitle: 'log',
            copyAction: '複製',
            noResponse: 'AI 未回傳結果',
            evaluateFailed: 'AI 分組評估失敗: {message}',
            groupTitleByIndex: '組別 {index}',
            groupTitleById: '組別 {groupId}'
        },
        country: '國家',
        city: '城市',
        district: '地區',
        datetime: '日期時間',
        aiModel: 'AI model',
        userList: '用戶列表',
        groupedTitle: '已分組',
        ungroupedTitle: '未分組',
        missingParams: '缺少城市或時間參數，請從分組頁進入。',
        loadFailed: '載入資料失敗',
        missingApiKey: '尚未設定 OpenRouter API Key。',
        permissionDenied: '權限不足無法使用',
        noParticipants: '目前沒有可用的參與者資料。',
        noCityTags: '目前沒有可用的城市標籤。',
        generating: 'AI 生成中...',
        generated: 'AI 已完成（Reasoning tokens: {tokens}）',
        noResponse: 'AI 未回傳內容。',
        generateFailed: 'AI 生成失敗',
        applyModelPending: '分組模型評估尚未啟用。',
        noGroupedData: '尚無已分組資料',
        modalTitle: 'AI 標籤建立',
        highRisk: '風險評估',
        highRiskModalTitle: '風險評估',
        highRiskModal: {
            runAction: 'AI風險評估',
            downloadAction: '下載報告',
            userListTitle: '用戶列表',
            emptyHint: '點擊「AI風險評估」按鈕開始評估',
            emptyList: '尚無標記資料',
            generatingStatus: 'AI 標記中',
            downloadNeedRunFirst: '請先完成 AI 風險評估後再下載報告',
            runFailed: '風險評估失敗，請稍後再試',
            detailAction: '詳細',
            reportOpenFailed: '無法開啟風險評估報告',
            table: {
                name: '姓名',
                tags: '標籤',
                introduction: '自我介紹',
                feedback: '回饋',
                risk: '風險判定'
            },
            feedback: {
                likes: '好評',
                normals: '普評',
                noShows: '放鳥',
                lates: '遲到',
                dislike: '負評',
                raterName: '姓名',
                remarks: '評語'
            },
            noFeedback: '無回饋',
            feedbackLoading: '回饋載入中',
            feedbackLoadFailed: '回饋讀取失敗',
            unknownUser: '未知用戶',
            parseFailed: '解析失敗',
            pending: '等待中'
        },
        highRiskDetail: {
            headers: {
                category: '類型',
                item: '項目',
                value: '內容'
            },
            categories: {
                analysis: '分析',
                interest_tags: '興趣標籤',
                risk: '風險',
                quality_score: '品質分數',
                recommended_action: '建議處置',
                blacklist_assessment: '黑名單判斷',
                tag_assessment: 'AI 標籤判斷',
                user_rating_assessment: '實際活動行為回饋',
                final_assessment: '綜合評估'
            },
            fields: {
                analysis: {
                    language_style: '語言風格',
                    social_vibe: '社交氛圍',
                    analysis: '分析內容'
                },
                interest_tags: {
                    tagItemPrefix: '標籤',
                    display_tag: '顯示標籤',
                    normalized_category: '標準分類',
                    social_attribute: '社交屬性',
                    items: '標籤項目'
                },
                risk: {
                    detected_flags: '命中旗標',
                    reason: '判定原因',
                    risk: '風險內容'
                },
                quality_score: {
                    quality_score: '品質分數'
                },
                recommended_action: {
                    recommended_action: '建議處置'
                },
                blacklist_assessment: {
                    level: '黑名單等級',
                    is_blacklisted: '是否黑名單',
                    severity: '嚴重程度',
                    risk_score: '風險值',
                    recommended_action: '建議處置',
                    reason: '判定原因'
                },
                tag_assessment: {
                    severity: '標籤嚴重程度',
                    risk_score: '標籤風險值',
                    negative_tags: '標籤負面項目',
                    neutral_or_positive_tags: '標籤中性/正面項目',
                    manual_risk_tags: '標籤特殊規則',
                    reason: '標籤判定原因'
                },
                user_rating_assessment: {
                    has_data: '是否有評價資料',
                    severity: '評價嚴重程度',
                    risk_score: '評價風險值',
                    confidence: '信心程度',
                    summary: '摘要',
                    positive_signal: '正面/普通訊號',
                    negative_signal: '負面訊號',
                    recommended_action: '建議處置',
                    reason: '評價判定原因'
                },
                final_assessment: {
                    '風險值': '風險值',
                    '風險總評': '風險總評',
                    severity: '嚴重程度',
                    recommended_action: '建議處置',
                    top_risk_sources: '主要風險來源',
                    decision_factors: '判斷因子'
                }
            }
        },
        promptTitle: '送出給 AI 的提示詞',
        resultTitle: 'AI 回傳結果',
        table: {
            groupId: 'Group ID',
            location: '地區',
            reservation: '訂位名稱',
            name: '姓名',
            uid: 'UID',
            email: 'Email',
            gender: '性別',
            tags: '標籤'
        }
    },

    // Toast Messages
    toasts: {
        // Group related toasts
        group: {
            groupnotfound: '找不到組別 {groupNumber}',
            modalnotfound: '找不到位置彈出視窗',
            groupedtotal: '已分組（共{totalPeople}人）',
            visitedrestaurantsfor: '{userName} 的造訪餐廳',
            recentlocationfor: '{userName} 的最近地點',
            novisitedrestaurants: '無造訪餐廳記錄。',
            user: '使用者',
            selectcity: '請選擇城市',
            selectdateandtime: '請選擇日期和時間',
            loaddataerror: '載入資料時發生嚴重錯誤，請檢查主控台',
            promocodeformaterror: '讀取本次優惠碼格式錯誤',
            promocodefailed: '讀取本次優惠碼失敗: {error}',
            cannotgetcitydatetime: '無法取得城市、日期或時間以進行自動分組',
            selectedpromocodes: '已選擇 {count} 個優惠碼，正在執行自動分組...',
            nopromocodes: '未選擇任何優惠碼，正在執行自動分組...',
            algogroupsuccess: '自動分組請求已成功！正在重新整理資料...',
            algogroupfailed: '自動分組失敗: {error}',
            modalnotinitialized: '自動分組對話框無法開啟，請稍後再試',
            cannotloadpromocodelist: '無法載入優惠碼列表至對話框',
            nopromocodesavailable: '目前沒有可用的優惠碼可供選擇。',
            updateungroupederror: '更新未分組資料時發生錯誤: {error}',
            fetchlocationserror: '獲取可分配位置時發生錯誤: {error}',
            updategroupederror: '更新已分組資料時發生錯誤: {error}',
            selectcitytoload: '請選擇城市以載入/更新資料',
            selectdatetimetoload: '請選擇日期和時間以載入/更新資料',
            selectcityforpromo: '請先選擇城市以載入優惠碼。',
            algogrouploading: '正在使用演算法進行分組，請耐心等待。',
            assignfailed: '分配操作未成功但未拋出錯誤',
            assignunknownerror: '分配時發生未知錯誤',
            cancelrefundsuccess: '已為 {userName} 提交退款申請。',
            cannotgetrestaurants: '無法取得可分配餐廳列表，請稍後再試',
            creategroupfailednoqn: '建立新群組失敗：伺服器未回傳有效的組別編號',
            creategroupsuccess: '新群組建立成功！',
            creategroupfailed: '建立新群組失敗：{error}',
            updategroupsuccess: '已成功更新 {groupNumber} 組資料',
            updategroupfailed: '更新 {groupNumber} 組資料失敗，請稍後再試',
            updategrouperror: '更新 {groupNumber} 組資料時發生錯誤：{error}',
            duplicaterestaurant: '此餐廳已被同城、同時間的其他分組（包含其他桌型）選擇，請更換餐廳後再儲存。',
            restaurantCheckFailed: '無法確認同城、同時間各桌型的餐廳占用狀態，尚未儲存。請稍後重試。',
            restaurantScopeChanged: '場次已變更，尚未儲存。請在目前場次重新操作。',
            grouplockedcannotassign: '組別已鎖定，無法分配項目',
            selectrestaurantforlockedgroup: '鎖定群組前請先選擇餐廳',
            noassignablerestaurants: '尚無可選餐廳，請至餐廳頁選擇訂位時段',
            moveschedulecitysuccess: '成功移動行程到新城市',
            moveschedulecityfail: '移動行程到新城市失敗',
            movescheduletimesuccess: '成功移動行程到新時間',
            movescheduletimefail: '移動行程到新時間失敗'
        },
        // API related toasts
        api: {
            notloggedin: '未登入或登入已過期'
        },
        // Restaurant related toasts
        restaurant: {
            namerequired: '餐廳名稱為必填項目',
            addressrequired: '餐廳地址為必填項目',
            googlemapsrequired: 'Google Maps 連結為必填項目',
            linktoolong: '餐廳連結不能超過 100 字元',
            updatesuccess: '餐廳資訊更新成功！',
            addsuccess: '餐廳新增成功！',
            updatefailed: '更新失敗，請稍後再試。',
            addfailed: '新增失敗，請稍後再試。',
            timeslotadded: '時段新增成功！',
            timeslotaddfailed: '時段新增失敗。',
            timeslotadderror: '新增時段錯誤：{error}',
            timeslotremoved: '時段移除成功！',
            timeslotremovefailed: '時段移除失敗。',
            timeslotremoveerror: '移除時段錯誤：{error}'
        },
        // Users related toasts
        users: {
            selectcityfirst: '請先選擇城市',
        tagremovesuccess: '標籤 "{tagName}" 已成功從用戶移除',
        tagremovefailed: '從用戶移除標籤失敗。',
        tagremoveerror: '移除標籤錯誤: {error}',
        tagupdatefailed: '更新標籤失敗。',
        tagupdateerror: '更新標籤錯誤: {error}',
        tagaddsuccess: '標籤 "{tagName}" 已成功添加到用戶',
            tagaddfailed: '添加標籤到用戶失敗。',
            tagadderror: '添加標籤錯誤: {error}',
            nocityselected: '未選擇城市，無法新增標籤。',
            newtagrequested: '標籤 "{tagName}" 已請求新增。正在更新列表...',
            newtagfailed: '新增標籤 "{tagName}" 失敗。伺服器未確認。',
            newtagfailederror: '新增標籤 "{tagName}" 失敗: {error}',
            saveoperationerror: '儲存操作錯誤，請刷新頁面。',
            missingnoteid: '無法儲存備註：缺少用戶ID。',
            noteupdated: '備註已更新!',
            noteupdatefailed: '備註更新失敗。',
            noteupdateerror: '備註更新失敗: {error}',
            selectcityforexport: '請先選擇一個城市才能匯出 Email 清單。',
            emailformatincorrect: '無法獲取 Email 清單，回傳格式錯誤。',
            noemailstoexport: '目前篩選條件下沒有 Email 可匯出。',
            emailexportsuccess: '已成功匯出 {count} 個 Email。',
            emailexportfailed: '匯出 Email 失敗: {error}',
            loadcitytagsfailed: '無法載入城市標籤: {error}'
        },
        selectcity: '請選擇城市',
        selectdate: '請選擇日期',
        selecttime: '請選擇時間',
        unknownerror: '未知錯誤',
        promocode: {
            invalidDiscountValue: '錯誤的折扣數字',
            promoCodeExists: '優惠碼已存在',
            addFailed: '新增優惠碼失敗',
            promoCodeRequired: '請輸入折扣碼',
            promoCodeTooLong: '折扣碼字元數不可超過15字元',
            countryRequired: '請選擇國家',
            expirationRequired: '請選擇到期日',
            usageLimitInvalid: '每帳號限用次數必須大於 0',
            totalQuantityInvalid: '總數量必須大於 0',
            percentageRangeInvalid: '百分比折扣值必須在 1-100 之間',
            discountFormatInvalid: '折扣輸入格式不正確，僅能輸入數字，小數點後兩位'
        },
        themetable: {
            invalidDiscountValue: '錯誤的售價數字',
            codeExists: '主題桌碼已存在',
            addFailed: '新增主題桌失敗',
            codeRequired: '請輸入主題桌碼',
            codeTooLong: '主題桌碼字元數不可超過15字元',
            countryRequired: '請選擇國家',
            expirationRequired: '請選擇到期日',
            usageLimitInvalid: '每帳號限用次數必須大於 0',
            totalQuantityInvalid: '總數量不可小於 0',
            percentageRangeInvalid: '百分比售價必須在 1-100 之間',
            discountFormatInvalid: '售價輸入格式不正確，僅能輸入數字，小數點後兩位'
        }
    },

    // API Error messages
    apiError: {
        sessionExpired: '未登入或登入已過期，請重新登入。',
        missingCityID: '缺少 cityID 參數。',
        apiCallFailed: 'API 呼叫失敗，狀態：{status} {statusText}',
        missingResumeEmails: '取得用戶郵箱列表需要 cityID。',
        missingCityTags: '取得城市標籤需要 cityID。',
        missingCityTagParams: '添加城市標籤需要 cityID 和 tagName。',
        addCityTagFailed: '由於 API 錯誤，無法添加城市標籤。',
        missingUpdateCityTagParams: '更新城市標籤需要 tagID 和 tagName。',
        updateCityTagFailed: '由於 API 錯誤，無法更新城市標籤。',
        missingRemoveCityTagParams: '刪除城市標籤需要 tagID。',
        removeCityTagFailed: '由於 API 錯誤，無法刪除城市標籤。',
        missingResumeTagParams: '添加履歷標籤需要 resumeID 和 tagID。',
        addResumeTagFailed: '由於 API 錯誤，無法添加履歷標籤。',
        missingRemoveTagParams: '刪除履歷標籤需要 resumeID 和 tagID。',
        removeResumeTagFailed: '由於 API 錯誤，無法刪除履歷標籤。',
        missingAgeParams: '更新實際年齡需要 resumeID 和 age。',
        invalidAge: '年齡必須是非負整數。',
        updateAgeFailed: '由於 API 錯誤，無法更新履歷實際年齡。',
        missingResumeID: '更新備註需要 resumeID。',
        emptyRemarks: '備註參數為 null 或 undefined，將作為空字符串發送。',
        updateRemarksFailed: '由於 API 錯誤，無法更新履歷備註。',
        missingUid: '獲取履歷評分需要 uid。',
        missingRatingParams: '評價履歷所需要 resumeID 和 rating。',
        invalidRating: '評分必須是 1 到 5 之間的整數。',
        rateResumeFailed: '由於 API 錯誤，評價履歷失敗。',
        missingVerificationID: '標記真人驗證失敗需要 resumeID。',
        setVerificationFailedError: '由於 API 錯誤，標記真人驗證失敗。',

        // Error codes
        error: {
            '10010': '尚未報名截止，無法更動',
            '10011': '找不到分組ID',
            '10012': '分組已鎖定',
            '10013': '分組與用戶所報名城市不同',
            '10014': '分組與用戶所報名時間不同',
            '10015': '用戶已被分組，無法取消',
            '10040': '推播時間已過，無法更改',
            '10050': 'EDM 使用中，無法更新'
        },
        
        // Restaurant API error messages
        missingCityIDForRestaurant: '餐廳操作需要 cityID。',
        restaurantHttpError: 'HTTP 錯誤！狀態：{status}',
        updateLocationError: '更新位置資訊失敗。',
        addLocationError: '新增位置失敗。',
        
        // Login API error messages
        missingCredentials: '需要提供電子郵件和密碼。',
        loginHttpError: '登入失敗。HTTP 錯誤！狀態：{status}',
        fetchCitiesError: '獲取可管理城市失敗。HTTP 錯誤！狀態：{status}',
        
        // Group API error messages
        groupHttpError: 'HTTP 錯誤！狀態：{status}',
        algoGroupFailed: '目前參加者資料無法分出適當組別。',
        updateRestaurantFailed: '更新餐廳失敗。',
        updateReservationFailed: '更新訂位名稱失敗。',
        assignmentFailed: '分配失敗。',
        unknownAssignmentError: '分配用戶到組別時發生未知錯誤。',
        invalidGroupID: '無法取得有效的組別ID。',
        invalidBookedValue: '無效的訂位值。必須是 0 (未訂位) 或 1 (已訂位)。',
        invalidLockedValue: '無效的鎖定值。必須是 0 (未鎖定) 或 1 (已鎖定)。',
        updateGroupInfoFailed: '更新群組資訊失敗。',
        unknownGroupUpdateError: '更新群組資訊時發生未知錯誤。',
        cancelRefundFailed: '退款失敗。',
        moveScheduleCityFailed: '移動行程城市失敗。',
        moveScheduleFailed: '移動行程時間失敗。',
        
        // Feedback API error messages
        feedbackHttpError: '獲取反饋數據失敗。HTTP 錯誤！狀態：{status}',
        feedbackStatsError: '獲取反饋統計數據失敗。HTTP 錯誤！狀態：{status}',
        feedbackLocationsError: '獲取反饋地點數據失敗。HTTP 錯誤！狀態：{status}'
    },

    // Restaurant
    restaurant: {
        add: '新增',
        edit: '編輯',
        update: '更新',
        name: '餐廳名稱（限制 45 字）',
        address: '地址',
        link: 'Link（限制 100 字元）',
        accessible: '是否開放',
        yes: '是',
        no: '否',
        addrestaurant: '新增餐廳',
        editrestaurant: '編輯餐廳',
        replies: '回覆數',
        approvalrate: '好評率',
        food: '食物',
        service: '服務',
        price: '價錢',
        all: '全部',
        liked: '喜歡',
        disliked: '不喜歡',
        people: '人',
        selectcityfirst: '請先選擇一個城市。',
        cannotloaddata: '無法載入',
        cityselectornotfound: '城市選擇器未找到，無法載入餐廳。',
        saturday: '六',
        sunday: '日',
        positive: '好評',
        negative: '負評',
        bookedtimes: '已訂位時段'
    },

    // Feedback
    feedback: {
        overallactivityfeedback: '整體活動回饋',
        overalltrend: '整體趨勢',
        responserate: '回覆率',
        positiverate: '好評率',
        negativerate: '負評率',
        userfeedback: '用戶回饋',
        noshowrate: '放鳥率',
        laterate: '遲到率',
        restaurantfeedback: '餐廳回饋',
        recommendrate: '推薦率',
        notrecommendrate: '不推薦率',
        evaluateandratedboth: '評價/被評價/皆顯示',
        evaluate: '評價',
        rated: '被評價',
        negativereview: '負評',
        noshow: '放鳥',
        notrecommend: '不推薦',
        negativeornoshowfilter: '請選擇',
        clear: '清除',
        givenevaluation: '給予評價',
        notrecommendtofriends: '不推薦給朋友的原因',
        like: '喜歡',
        dislike: '不喜歡',
        normal: '一般',
        late: '遲到',
        noevaluationdata: '無評價資料',
        clicktocopyuid: '點擊複製 UID',
        clicktoviewuser: '點擊查看用戶',
        restaurantselecterror: '更新餐廳選擇下拉選單時發生錯誤',
        selectrestaurant: '選擇餐廳',
        noreasonprovided: '不推薦但未填原因',
        otherreasons: '其它原因',
        aiweeklyanalysis: 'AI 活動回饋週分析'
    },

    feedbackAiAnalysis: {
        title: 'AI 活動回饋分析',
        backToFeedback: '返回',
        pageDescription: '依據目前篩選條件預先載入回饋與統計資料，確認資料 ready 後可選擇當週或多週比較分析。',
        filterScope: '分析範圍',
        analysisMode: '分析模式',
        weeklyMode: '當週分析',
        multiWeekMode: '多週比較分析',
        weeklyModeHelp: '以日期區間中的最新週作為當週，對照前週與近四週平均。',
        multiWeekModeHelp: '分析整個日期區間的週別平均、走勢、波動與主要轉折。',
        dataStatus: '資料狀態',
        metricOverview: '當週指標',
        multiWeekOverview: '多週總覽',
        evidenceOverview: '資料依據摘要',
        aiAnalysis: 'AI 分析結果',
        runAnalysis: '執行 AI 分析',
        rerunAnalysis: '重新分析',
        copyResult: '複製結果',
        loadingData: '資料載入中',
        dataReady: '資料已 ready',
        dataFailed: '資料載入失敗',
        missingRequiredFilters: '缺少城市或日期區間，無法載入分析資料。',
        noData: '目前篩選條件沒有足夠資料可分析。',
        emptyState: '資料 ready 後，請手動執行 AI 分析。',
        analyzing: 'AI 正在分析本週回饋',
        analyzingMultiWeek: 'AI 正在分析多週回饋',
        analysisFailed: 'AI 分析失敗，請稍後再試。',
        copied: '分析結果已複製',
        city: '城市',
        dateRange: '日期區間',
        groupID: 'Group ID',
        uid: 'UID',
        feedbackType: 'UID 模式',
        negativeFilter: '負評篩選',
        restaurant: '餐廳',
        all: '全部',
        currentMode: '目前模式',
        currentWeek: '當週',
        previousWeek: '前週',
        fourWeekAverage: '近四週平均',
        delta: '差異',
        weekOf: '週別',
        mainChange: '主要變化',
        recommendRate: '推薦率',
        notRecommendRate: '不推薦率',
        userPositiveRate: '用戶好評率',
        userNegativeRate: '用戶負評率',
        restaurantPositiveRate: '餐廳好評率',
        restaurantNegativeRate: '餐廳負評率',
        feedbackRows: '回饋筆數',
        groups: '活動組數',
        restaurants: '餐廳數',
        attendeeReviews: '用戶互評數',
        statsWeeks: '統計週數',
        analysisWeeks: '分析週數',
        dateRangeDays: '區間天數',
        latestWeek: '最新週',
        averageRecommendRate: '平均推薦率',
        averageNotRecommendRate: '平均不推薦率',
        mostVolatileMetric: '波動最大指標',
        biggestChange: '最大單週變化',
        weekCountSummary: '共 {count} 週統計',
        noPreviousWeek: '無前週可比較',
        evidenceScope: '佐證範圍',
        weeklyEvidenceScope: '使用 {week} 當週回饋佐證，共 {count} 筆',
        weeklyEvidenceScopeFallback: '無法將回饋明細穩定對應到 {week}，暫以完整區間佐證，共 {count} 筆',
        multiWeekEvidenceScope: '使用完整日期區間回饋佐證，共 {count} 筆',
        topNotReferReasons: '不推薦原因',
        topUserNegativeTags: '用戶負評標籤',
        topLocationNegativeTags: '餐廳負評標籤',
        representativeComments: '代表性文字回饋',
        noEvidence: '沒有可彙整的文字或標籤資料。',
        summary: '分析摘要',
        trendSummary: '趨勢摘要',
        turningPoints: '轉折週',
        keyFindings: '主要發現',
        metricAnalysis: '指標分析',
        rootCauseHypotheses: '可能根因假設',
        recommendedActions: '建議處理事項',
        followUpQuestions: '建議補查問題',
        limitations: '資料限制',
        rawResponse: 'AI 原始回覆',
        evidence: '依據',
        confidence: '信心程度',
        whyItFits: '符合原因',
        gap: '缺口',
        nextCheck: '下一步檢查',
        reason: '原因',
        owner: '建議負責方',
        successSignal: '成效觀察'
    },

    // Users
    users: {
        uidSearch: '輸入UID搜尋',
        emailList: 'Email清單',
        gender: '性別',
        male: '男',
        female: '女',
        signups: '參加次數',
        times0: '0次',
        times1: '1次',
        times2: '2次',
        times3plus: '3次以上',
        age: '年紀',
        under40: '40以下',
        over40: '40(含)以上',
        rating: '評價',
        score1: '1分',
        score2: '2分',
        score3: '3分',
        score4plus: '4分(含)以上',
        introduction: '自介',
        notfilled: '未填寫',
        filled: '已填寫',
        blacklist: '黑名單',
        notblacklisted: '非黑名單',
        blacklisted: '已設為黑名單',
        blacklistL1: '已設為黑名單L1',
        blacklistL2Plus: '已設為黑名單L2以上',
        excludetags: '排除',
        includetags: '篩選',
        alltags: '所有標籤',
        tagsLabel: '標籤',
        currentFiltersLabel: '目前篩選：',
        tagFilterIncludeLabel: '標籤篩選：',
        tagFilterExcludeLabel: '標籤排除：',
        selectedtags: '已選標籤',
        noSelectedTags: '尚未選擇任何標籤',
        noAvailableTags: '目前沒有可用的標籤',
        notes: '備註',
        editage: '編輯年齡',
        systemage: '系統年齡',
        actualage: '實際年齡',
        adminNotePlaceholder: '管理員備註',
        userRatingsModalTitle: '{userName}的用戶評價',
        userRatingsSectionTitle: '用戶評價',
        blacklistStatusSectionTitle: '黑名單狀態',
        positiveReviews: '好評',
        normalReviews: '普通',
        negativeReviews: '負評',
        noShow: '放鳥',
        lateArrival: '遲到',
        nonegativefeedback: '尚無負評',
        blacklistPhotoCount: '照片數量',
        blacklistInternalRating: '內部評分',
        blacklistActualAge: '真實年齡',
        blacklistMarkUp: '加價標記',
        blacklistDislikes: '負評',
        blacklistAbsents: '放鳥',
        unmarked: '尚未標記',
        loadBlacklistStatusFailed: '黑名單狀態載入失敗',
        goodRates: '好評',
        refunded: '已退款',
        language: '語言',
        nationality: '國籍',
        usingcitylanguage: '使用城市語言',
        notusingcitylanguage: '非城市語言',
        totalUsersLabel: '(共 {count} 人)'
    },

    // Rate Modal specific
    rate: {
        verificationfailed: '標記為真人驗證失敗',
        verificationfailedreported: '真人驗證失敗已回報',
        ratingsaved: '評分已儲存',
        noverificationphoto: '未提供驗證照片',
        verificationFailedBadgeText: '真人驗證失敗',
        verificationfailedreporterror: '真人驗證失敗回報錯誤，請稍後再試。',
        pleaseselectrating: '請選擇評分。',
        ratingsavefailed: '儲存評分失敗，請稍後再試。',
        confirmVerificationFailed: '確定要標記為真人驗證失敗嗎？'
    },

    // Billing
    billing: {
        applicantcount: '報名人次',
        newcustomer: '新客',
        returningcustomer: '舊客',
        revenue: '營收',
        repurchaserate: '回購率',
        customerratio: '新舊客比例',
        accounting: '帳務',
        filterSection: '篩選',
        signupOverview: '報名總覽',
        participantList: '參加者列表',
        paymentStatusFilterSection: '參加狀態篩選',
        attendedParticipants: '已參加',
        refundedParticipants: '已退款',
        income: '收入',
        stripeSettlementAmount: 'Stripe 結算金額（USD）',
        stripeSettlementTooltip: '依 Stripe 換匯之美元金額',
        usd: '美元',
        fee: '手續費',
        tappayFee: 'TapPay 手續費',
        stripeFee: 'Stripe 手續費',
        tax: '稅額',
        profit: '盈利',
        captured: '已請款',
        uncaptured: '未請款',
        uncapturedIncomeNote: '不包含 {count} 筆未請款交易',
        totalAttendance: '總出席人數',
        participant: '參加者',
        groupID: '群組',
        meetTime: '會面時間',
        promoCode: '優惠碼',
        price: '付款金額',
        usdAmount: 'Stripe 結算金額（USD）',
        paymentFee: '手續費',
        paidTime: '付款時間',
        paymentStatus: '付款狀態',
        refundStatus: '退款',
        payTime: '付款',
        refundTime: '退款',
        refunded: '已退款',
        noPaymentsFound: '此日期區間沒有付款紀錄。',
        noCanceledFeesFound: '此日期區間沒有退款紀錄。',
        selectCityFirst: '請先選擇一個城市。',
        loadedPayments: '已載入 {count} 筆',
        cannotloaddata: '無法載入計費資料',
        apierror: 'API 錯誤'
    },

    // Promo Code
    promocode: {
        title: '新增優惠碼',
        editTitle: '編輯優惠碼',
        typeLabel: '類型',
        promoType: '優惠碼',
        publicType: '主題桌',
        promoCode: '優惠碼(15字內)',
        promoCodeLabel: '優惠碼(15字內)',
        publicCodeLabel: '主題桌碼(15字內)',
        promoCodePlaceholder: 'hello{rrr} 或留空自動生成',
        generateCode: '生成隨機碼',
        generateShare: '分享優惠',
        generateComp: '補償優惠',
        generateFree: '免費',
        formatDescription: '生成隨機碼',
        formatExamples: '• 數字隨機：hello{nnnn} → hello1325, {nnn} → 123, {nn} → 12, {n} → 1<br>• 英數隨機：hello{rrr} → hello3ar1, {rr} → a2, {r} → x<br>• 用戶生日：hello{yyyy} → hello1990, {yy} → 90<br>• 留空自動生成隨機格式的折扣碼<br><br>分享優惠：share + (YYM) + 3位英文隨機碼<br>補償優惠：comp + (YYM) + 3位英文隨機碼<br>免費：free + (YYM) + 3位英文隨機碼',
        selectCountry: '選擇國家',
        selectCity: '選擇城市',
        timeSlot: '指定時段',
        expirationDate: '到期日',
        usageLimit: '每帳號限用次數',
        totalQuantity: '總數量（上限為255）',
        unlimited: '無限',
        discountType: '優惠碼性質',
        publicDiscountType: '主題桌售價性質',
        percentage: '百分比',
        fixedAmount: '固定金額',
        discount: '折扣',
        publicDiscount: '售價',
        publicPercentagePrefix: '原價 X',
        publicPercentageSuffix: '% = 售價',
        publicFixedPrefix: '原價 -',
        publicFixedSuffix: '= 售價',
        firstTimeOnly: '限未參加過用戶',
        notes: '備註（可選）',
        publicNotes: '主題桌敘述',
        notesPlaceholder: '輸入備註...',
        publicTitlePlaceholder: '請輸入主題桌名稱',
        publicDetailsPlaceholder: '請輸入主題桌介紹文',
        generalNotesSection: '一般備註',
        generalDetailsLabel: '備註',
        generalDetailsHint: '（限100字）',
        addLocale: '新增語言 +',
        selectLanguage: '請選擇語言',
        confirm: '確認',
        noLocaleData: '目前沒有可用的語言資料',
        localeRequired: '請先選擇語言',
        add: '新增',
        update: '更新',
        cancel: '取消',
        processing: '處理中...',
        
        // Table headers
        edit: '編輯',
        code: '折扣碼',
        location: '地區',
        status: '狀態',
        type: '性質',
        value: '折扣值',
        currency: '幣別',
        expiration: '到期時間',
        firstTime: '限未參加過用戶',
        perUser: '每帳號限用次數',
        totalLimit: '總數量',
        usedCount: '已使用次數',
        details: '備註',
        
        // Messages
        addSuccess: '優惠碼新增成功！',
        updateSuccess: '優惠碼更新成功！',
        addFailed: '新增優惠碼失敗',
        updateFailed: '更新優惠碼失敗',
        promoCodeRequired: '請輸入折扣碼',
        countryRequired: '請選擇國家',
        cityRequired: '請選擇城市',
        expirationRequired: '請選擇到期日',
        usageLimitInvalid: '每帳號限用次數必須大於 0',
        totalQuantityInvalid: '總數量必須大於 0',
        percentageRangeInvalid: '百分比折扣值必須在 1-100 之間',

        noPromoCodesFound: '沒有找到優惠碼資料',
        loadCountryFailed: '載入國家優惠碼失敗',
        loadCityFailed: '載入城市優惠碼失敗',
        promoCodeNotFound: '找不到指定的優惠碼',
        loadDataFailed: '載入資料失敗',
        noCountriesAvailable: '沒有可用的國家',
        noPermissionToEdit: '沒有權限可編輯',
        all: '全部',
        unexpiredFilter: '未到期',
        expiredFilter: '已到期',
        yes: '是',
        no: '否',
        active: '啟用',
        expired: '關閉'
    },

    themetable: {
        title: '新增主題桌',
        editTitle: '編輯主題桌',
        codeLabel: '主題桌碼(15字內)',
        codePlaceholder: 'hello{rrr} 或留空自動生成',
        generateCode: '生成隨機碼',
        generateShare: '分享優惠',
        generateComp: '補償優惠',
        generateFree: '免費',
        formatDescription: '生成隨機碼',
        formatExamples: '• 數字隨機：hello{nnnn} → hello1325, {nnn} → 123, {nn} → 12, {n} → 1<br>• 英數隨機：hello{rrr} → hello3ar1, {rr} → a2, {r} → x<br>• 用戶生日：hello{yyyy} → hello1990, {yy} → 90<br>• 留空自動生成隨機格式的主題桌碼<br><br>分享優惠：share + (YYM) + 3位英文隨機碼<br>補償優惠：comp + (YYM) + 3位英文隨機碼<br>免費：free + (YYM) + 3位英文隨機碼',
        selectCountry: '選擇國家',
        selectCity: '選擇城市',
        timeSlot: '指定時段（可選）',
        expirationDate: '到期日',
        usageLimit: '每帳號限用次數',
        totalQuantity: '總數量（0為無限制，上限為255）',
        unlimited: '無限',
        discountType: '主題桌售價性質',
        percentage: '百分比',
        fixedAmount: '固定金額',
        discount: '售價',
        percentagePrefix: '原價 X',
        percentageSuffix: '% = 售價',
        fixedPrefix: '原價 -',
        fixedSuffix: '= 售價',
        firstTimeOnly: '限未參加過用戶',
        notes: '主題桌敘述',
        titleLabel: '名稱',
        titleHint: '（限20字）',
        detailsLabel: '介紹文',
        detailsHint: '（限200字）',
        titlePlaceholder: '請輸入主題桌名稱',
        detailsPlaceholder: '請輸入主題桌介紹文',
        generalNotesSection: '一般備註',
        generalDetailsLabel: '備註',
        generalDetailsHint: '（限100字）',
        addLocale: '新增語言 +',
        selectLanguage: '請選擇語言',
        confirm: '確認',
        localeRequired: '請先選擇語言',
        add: '新增主題桌',
        update: '更新',
        cancel: '取消',
        processing: '處理中...',
        edit: '編輯',
        code: '主題桌碼',
        location: '地區',
        status: '狀態',
        value: '售價',
        expiration: '到期時間',
        firstTime: '限未參加過用戶',
        perUser: '每帳號限用次數',
        totalLimit: '總數量',
        usedCount: '已使用次數',
        details: '主題桌敘述',
        addSuccess: '主題桌新增成功！',
        updateSuccess: '主題桌更新成功！',
        addFailed: '新增主題桌失敗',
        updateFailed: '更新主題桌失敗',
        noThemeTablesFound: '沒有找到主題桌資料',
        loadCountryFailed: '載入國家主題桌失敗',
        loadCityFailed: '載入城市主題桌失敗',
        noCountriesAvailable: '沒有可用的國家',
        noPermissionToEdit: '沒有權限可編輯',
        themeTableNotFound: '找不到指定的主題桌',
        loadDataFailed: '載入資料失敗',
        all: '全部',
        unexpiredFilter: '未到期',
        expiredFilter: '已到期',
        yes: '是',
        no: '否',
        active: '啟用',
        expired: '關閉',
        scheduleManagementTab: '主題桌時段管理',
        cityManagementTab: '桌型管理',
        reload: '重新讀取',
        actions: '操作',
        meetTypeID: 'Meet Type ID',
        meetTypeName: '類型識別名稱',
        markUp: '加價金額',
        category: 'category',
        localeCount: '語系數量',
        country: '國家',
        city: '城市',
        available: '開放狀態',
        availableOpen: '開放',
        availableClosed: '關閉',
        addCityMeetType: '新增主題桌',
        editCityMeetType: '編輯主題桌',
        cityMeetTypesSummary: '桌型 ({count})',
        loading: '載入中...',
        loadedMeetTypes: '已載入 {count} 筆桌型',
        loadMeetTypesFailed: '載入桌型失敗',
        selectCityFirst: '請先選擇城市',
        noMeetTypesFound: '此城市尚無主題桌資料',
        meetTypeFieldsRequired: '請輸入類型識別名稱與最多兩位小數的非負加價金額',
        categoryRequired: 'category 必須是 1 或 2',
        createMeetTypeSuccess: '桌型新增成功',
        createMeetTypeFailed: '桌型新增失敗',
        updateMeetTypeSuccess: '桌型更新成功',
        updateMeetTypeFailed: '桌型更新失敗',
        addMeetTypeLocale: '新增主題桌語系',
        editMeetTypeLocale: '編輯主題桌語系',
        noLocaleConfigured: '尚未設定語系內容',
        locale: '語系',
        localeID: 'Locale ID',
        localeTitle: '顯示標題',
        localeDetails: '詳細說明',
        cityMeetType: '桌型',
        localeFieldsRequired: '請完整填寫桌型、語系、顯示標題與詳細說明',
        addMeetTypeLocaleSuccess: '主題桌語系新增成功',
        addMeetTypeLocaleFailed: '主題桌語系新增失敗',
        updateMeetTypeLocaleSuccess: '主題桌語系更新成功',
        updateMeetTypeLocaleFailed: '主題桌語系更新失敗'
    },

    seasonpass: {
        selectCountry: '選擇國家',
        selectCity: '選擇城市',
        filterActionsSection: '篩選與操作',
        statusFilterSection: '狀態篩選',
        summary: '帳務',
        purchasers: '購買人數',
        revenue: '營收',
        usdRevenue: '美金收入',
        fee: '手續費',
        tax: '稅額',
        profit: '盈利',
        code: '季票通行碼',
        status: '狀態',
        discount: '金額',
        price: '付款金額',
        usd: '美金',
        usedCount: '已使用/總次數',
        totalLimit: '總次數',
        perUser: '每帳號限用次數',
        period: '期限',
        payTime: '付款時間',
        expirationTime: '到期時間',
        note: '購買人',
        to: '至',
        unexpiredFilter: '未到期',
        expiredFilter: '已到期',
        active: '啟用',
        expired: '關閉',
        authorized: '已授權',
        captured: '已結算',
        uncapturedStatus: '未結算',
        uncapturedRevenueNote: '不包含未請款交易',
        captureTime: '請款時間',
        expiredBadge: '已過期',
        usedUpBadge: '使用完畢',
        startDate: '開始日期',
        endDate: '結束日期',
        noSeasonPassesFound: '沒有找到季票資料',
        loadFailed: '載入季票資料失敗',
        emailListButton: 'Email清單',
        noAvailableEmails: '沒有可下載的 Email 清單',
        emailListDownloaded: '已下載 Email 清單（共 {count} 筆）'
    },

    // Review
    review: {
        photo: '照片',
        photoVerification: '照片驗證',
        reverifyMode: '重新驗證',
        verificationSuccess: '驗證成功',
        verificationFailed: '驗證失敗',
        verificationUpdated: '照片驗證已更新',
        ageWithValue: '年齡:{age}',
        ageUnknown: '年齡:-',
        idLabel: 'ID: {id}',
        lastManagementVerification: '上次管理員驗證時間',
        lastUserVerificationUpload: '上次用戶上傳驗證照',
        notePlaceholder: '請輸入備註...',
        selectCityFirst: '請先選擇一個城市。',
        noReviewData: '此城市尚無評論資料。',
        loadReviewFailed: '無法載入 {city} 的評論資料。',
        citySelectorMissing: '城市選擇器未找到，無法載入評論。',
        ratingButtonsAria: '評分按鈕'
    },

    // Notification
    notification: {
        directPromoCode: "優惠碼（選填）",
        directNoPromoCode: "不使用優惠碼",
        directPromoLoading: "載入優惠碼中…",
        directPromoEmpty: "此地區沒有可用優惠碼。",
        directPromoFailed: "優惠碼載入失敗，請重新開啟視窗重試；仍可不使用優惠碼送出。",
        pushToThisUser: "推播給此用戶",
        directMissingResume: "缺少此用戶的 Resume ID，無法送出推播。",
        notifyResume: "指定用戶推播",
        directContent: "推播內容",
        directSend: "送出推播",
        directSending: "送出中…",
        directRequired: "請填寫 Resume ID 與推播內容。",
        directSuccess: "推播請求已送出",
        directFailed: "推播請求未確認成功，請先確認結果再重試。",

        title: '推播',
        add: '新增內容',
        content: '內容',
        target: '對象',
        type: '類型',
        push: '推播',
        message: '通知',
        email: 'Email',
        allUsers: '全部用戶',
        newUsers: '新用戶',
        activeUsers: '活躍用戶',
        language: '語言',
        sendStatus: '發送狀態',
        sendTime: '發送時間',
        all: '全部',
        sent: '發送完畢',
        pending: '待發送',
        selectCityFirst: '請先選擇城市',
        selectCityForAdd: '請先選擇城市',
        cannotLoadData: '無法載入城市',
        citySelectorNotFound: '找不到城市選擇器，無法載入通知。',
        totalUsers: '總數：{count} 人',
        devices: '發送裝置數',
        view: '查看',
        none: '無',
        allUsersAudience: '所有人',
        copyHint: '點擊複製',
        invalidDataFormat: '通知資料格式錯誤',
        gender: '性別',
        male: '男性',
        female: '女性',
        age: '年齡',
        underForty: '小於 40 歲',
        fortyAndOver: '大於或等於 40 歲',
        blacklist: '黑名單',
        blacklistL2OrAbove: '大於或等於 L2',
        rating: '評分',
        ratingFourOrAbove: '大於或等於 4',
        signUps: '報名次數',
        signUpsThreeOrAbove: '大於或等於 3',
        includeTags: '包含標籤',
        excludeTags: '排除標籤',

        // Edit Page
        editTitle: '編輯內容',
        country: '國家',
        city: '城市',
        selectCountry: '選擇國家',
        selectCity: '選擇城市',
        selectLanguage: '選擇語言',
        areaSection: '地區',
        audienceSection: '發送對象',
        audienceLanguageHint: '將發送給使用「{language}」的用戶',
        languageSelectionSection: '語言選擇',
        pushContentSection: '推播內容',
        notificationDetailsSection: '通知內容',
        expandDetails: '展開',
        collapseDetails: '收合',
        sendTimeSection: '發送時間',
        formContent: '內容',
        promoCode: '優惠碼',
        selectPromoCode: '不指定優惠碼',
        loadPromoCodesFailed: '優惠碼載入失敗',
        promoName: '優惠碼',
        englishContent: '英文內容',
        localLanguage: '當地語言',
        localContent: '當地內容',
        contentLabelSuffix: '內容',
        publishNotification: '同時發佈通知',
        formSendTime: '發送時間',
        sendNow: '即時發送',
        sendScheduled: '預約時間',
        date: '日期',
        hour: '時',
        minute: '分',
        second: '秒',
        contentPlaceholder: '請輸入通知內容',
        aiSuggestBtn: 'AI建議',
        aiSuggestTooltip: '此功能為AI建議的推播廣宣內容',
        aiSuggestDetailsTooltip: '此功能為AI建議的通知詳細廣宣內容',
        aiSuggestProcessing: '產生中...',
        aiSuggestLanguageRequired: '請先選擇語言，再使用 AI 建議',
        aiSuggestSuccess: 'AI 建議內容已填入',
        aiSuggestFailed: 'AI 建議內容產生失敗',
        aiSuggestEmpty: 'AI 未回傳可用內容',
        aiSuggestDetailsPushRequired: '請先輸入推播內容，再產生通知內容',
        aiSuggestDetailsSuccess: 'AI 建議通知內容已填入',
        aiSuggestDetailsFailed: 'AI 建議通知內容產生失敗',
        aiSuggestDetailsFormatFailed: 'AI 回傳格式錯誤，請再試一次',
        promoNamePlaceholder: '請輸入優惠碼',
        englishContentPlaceholder: '請輸入英文通知內容',
        localContentPlaceholder: '請輸入當地語言通知內容',
        cancel: '取消',
        deleteDetails: '刪除',
        addBtn: '新增',
        updateBtn: '更新',
        submitProcessing: '提交中...',
        updateProcessing: '更新中...',
        deleteProcessing: '刪除中...',
        loadLanguageFailed: '載入失敗',
        loadLanguageOptionsFailed: '載入語言選項失敗：{error}',
        loadPageDataFailed: '頁面初始化失敗',
        missingRequiredParams: '缺少必要參數，請返回通知列表頁重新操作。',
        countryOrCitySelectorNotFound: '國家或城市選擇器未找到',
        selectorInitTimeout: '選擇器初始化超時，請重新整理頁面',
        testModeParamsLogged: '測試模式：已檢查參數，未送出通知',

        // Toasts
        cityRequired: '請選擇城市',
        languageRequired: '請選擇語言',
        contentRequired: '請輸入通知內容',
        contentTooLong: '內容不可超過 {limit} 字',
        promoNameRequired: '請輸入優惠碼',
        englishContentRequired: '請輸入英文內容',
        localLanguageRequired: '請選擇當地語言',
        localContentRequired: '請輸入當地內容',
        dateRequired: '請選擇發送日期',
        timeRequired: '請選擇完整的發送時間（時、分、秒）',
        timeInvalid: '預約時間必須晚於現在時間',
        addSuccess: '通知已成功新增',
        addFailed: '新增通知失敗',
        addFailedWithError: '新增通知失敗：{error}',
        updateSuccess: '通知已成功更新',
        updateFailed: '更新通知失敗',
        deleteDetailsSuccess: '通知內容已刪除',
        deleteDetailsFailed: '刪除通知內容失敗',
        noDetailsToDelete: '沒有可刪除的通知內容',
        notificationNotFound: '找不到通知',
        notificationIDMissing: '新增通知成功，但 API 未回傳 notificationID，無法新增通知內容',
        loadEditDataFailed: '載入編輯資料失敗',
        authError: '管理員認證資訊不完整'
    }
}; 
